import React from "react";
import { Col, Row } from "react-bootstrap";
import Global_map_buckets from "./global_map_buckets/Global_map_buckets"
import ActiveUsersData from "./activeUsersData/ActiveUsersData";
import ActiveUsers from "./activeUsers/ActiveUsers";

function Global_map() {
  return (
    <>
      <section className="Global_map">
        <Row>
          <Col lg={12} className="mb-3">
            <Global_map_buckets/>
          </Col>
          <Col lg={8} className="mb-3">
            <ActiveUsers />
          </Col>
          <Col lg={4} className="mb-3">
            <ActiveUsersData />
          </Col>
        </Row>
      </section>
    </>
  );
}

export default Global_map;
